import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCustomersApi,
  addCustomerApi,
  updateCustomerApi,
  deleteCustomerApi,
} from "../services/CustomerService";

// Fetch all customers and dropdown data
export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async (searchText = "") => {
    const response = await fetchCustomersApi(searchText);
    return response;
  }
);

// Add a new customer
export const addCustomer = createAsyncThunk(
  "customers/addCustomer",
  async (customerData) => {
    const response = await addCustomerApi(customerData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Update a customer
export const updateCustomer = createAsyncThunk(
  "customers/updateCustomer",
  async (customerData) => {
    const response = await updateCustomerApi(customerData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Delete a customer
export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async ({ customerId, currentUserId }) => {
    const response = await deleteCustomerApi(customerId, currentUserId);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

const customerSlice = createSlice({
  name: "customers",
  initialState: {
    customers: [],
    plans: [],
    areas: [],
    staff: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch customers
      .addCase(fetchCustomers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.customers = action.payload.customer || [];
        state.plans = action.payload.plan || [];
        state.areas = action.payload.area || [];
        state.staff = action.payload.staff || [];
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Add customer
      .addCase(addCustomer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addCustomer.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addCustomer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Update customer
      .addCase(updateCustomer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCustomer.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Delete customer
      .addCase(deleteCustomer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteCustomer.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default customerSlice.reducer;
